export default {
    "fr": {
        "Your are linked to the company account of": "Vous êtes rattachés au compte de l'entreprise",
        "Account parameters": "Paramètres du compte",
        "Books": "Mes réservations",
        "Clients": "Mes clients",
        "canceled": "Annulée",
        "Dashboard": "Tableau de bord",
        "Documents": "Mes documents",
        "EORI": "Numéro EORI",
        "Invoices": "Mes factures",
        "Mission reports": "Mes rapports d'intervention",
        "Mission report": "Rapport d'intervention",
        "Missions": "Mes interventions",
        "Name": "Nom",
        "Profile": "Mon profil",
        "Reports": "Mes rapports d'intervention",
        "Tva": "Numéro TVA",
        "Profile updated": "Votre profile est à jour",
        "Delete account": "Supprimer le compte",
        "Delete account message": "Une fois votre compte supprimé, il n'est plus possible de revenir en arrière.",
        "Tutorials": "Tutoriels",
        "Notifications": "Mes notifications",
        "Conversation": "Conversation"
    },
    "en": {
        "Your are linked to the company account of": "Your are linked to the company account of",
        "Account parameters": "Account parameters",
        "Books": "Bookings",
        "Clients": "My clients",
        "canceled": "Canceled",
        "Dashboard": "Dashboard",
        "Documents": "Documents",
        "EORI": "EORI number",
        "Invoices": "My invoices",
        "Mission reports": "Mission reports",
        "Mission report": "Mission report",
        "Missions": "Missions",
        "Name": "Name",
        "Profile": "Profile",
        "Reports": "Reports",
        "Tva": "TVA number",
        "Profile updated": "Profile updated",
        "Delete account": "Delete account",
        "Delete account message": "Once your account is deleted, it is no longer possible to go back.",
        "Tutorials": "Tutorials",
        "Notifications": "Notifications",
        "Conversation": "Conversation"
    }
}
